module.exports = __webpack_public_path__ + "static/media/landing-page.d490db99.png";